<template>
  <div>
    <el-container class="padding p-3">
      <el-form inline>
        <el-form-item label="經銷商">
          <selectCompany :id.sync="company_id" @onSelect="onSelectCompany" />
          <el-button v-if="selected.length && $route.meta.action.d" type="danger" @click="deleteProducts"> 刪除 </el-button>
        </el-form-item>
        <el-form-item>
          <ExportExcel v-if="$route.meta.action.e" :export-data="exportData.rows" :columns="columns" :filename="'商品資料'" @onExportClick="onExportClick" />
        </el-form-item>
      </el-form>
    </el-container>

    <div class="text-right">
      <el-pagination background :current-page.sync="currentPage" :page-sizes="[10, 20, 50]" :page-size="size" layout="sizes, prev, pager, next" :total="products.count" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
    </div>
    <el-table :data="products.rows" style="width: 100%" stripe @selection-change="handleSelectionChange">
      <el-table-column v-if="$route.meta.action.d" type="selection" width="55" />
      <el-table-column prop="ProductNo" label="品號" width="80" />
      <el-table-column prop="ProductNa" label="品名" />
      <el-table-column prop="UnitPrice" label="單價" width="80" />
    </el-table>
    <div class="text-right">
      <el-pagination background :current-page.sync="currentPage" :page-sizes="[10, 20, 50]" :page-size="size" layout="sizes, prev, pager, next" :total="products.count" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
    </div>
  </div>
</template>

<script>
import { getProducts, deleteProducts, getProductsByCompany, getComProducts } from '@/api/product';
import selectCompany from '@/components/select/companies';
import ExportExcel from '@/components/ExportExcel/index.vue';
const methods = {
  async onSelectCompany() {
    this.products = await getComProducts({ company_id: this.company_id });
    this.currentPage = 1;
  },
  async onExportClick() {
    this.exportData = await getComProducts({
      company_id: this.company_id,
      size: 5000,
      page: 1,
    });
  },
  async deleteProducts() {
    const data = await deleteProducts(this.selected);
    if (data) {
      this.$message({
        message: '成功',
        type: 'success',
      });
    }
    this.onSelectCompany();
  },
  handleSelectionChange(rows) {
    this.selected = rows;
  },
  async handleSizeChange(size) {
    this.size = size;
    this.products = await getComProducts({
      company_id: this.company_id,
      size: this.size,
    });
  },
  async handleCurrentChange(page) {
    this.products = await getComProducts({
      company_id: this.company_id,
      page,
      size: this.size,
    });
  },
};
export default {
  components: {
    ExportExcel,
    selectCompany,
  },
  data() {
    return {
      products: {
        rows: [],
        count: 0,
      },
      currentPage: 1,
      size: 10,
      selected: [],
      columns: [
        { label: '經銷商代號', field: 'VendorNo' },
        { label: '品號', field: 'ProductNo' },
        { label: '名稱', field: 'ProductNa' },
        { label: '單價', field: 'UnitPrice' },
      ],
      company_id: 1,
      exportData: {},
    };
  },
  created() {},
  methods,
};
</script>
